import React from 'react';
import { Label } from '../../../common/labels/labelTypes';
import { Tag as LabelPill, TagGroup as LabelGroup, TagList as LabelList } from '@milanote/roma';
import { List } from 'immutable';

type LabelElementPillsContainerProps = {
    labels: List<Label>;
    size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
};

const LabelElementPillsContainer: React.FC<LabelElementPillsContainerProps> = ({ labels, size }) => {
    if (!labels.size) return null;

    return (
        <div className="LabelElementPillsContainer mb-1 mr-1">
            <LabelGroup label="Labels list mb-1" size={size}>
                <LabelList className="flex flex-wrap gap-1">
                    {labels.map((label) => {
                        if (!label) return null;

                        return (
                            <LabelPill key={label.id} color={label.color}>
                                {label.name}
                            </LabelPill>
                        );
                    })}
                </LabelList>
            </LabelGroup>
        </div>
    );
};

export default LabelElementPillsContainer;
